/*! DO NOT EDIT: This file is auto-generated and will be overwritten. [build-fingerprint:assets:source={/app/_js/standalone/collection/index.js}] */
"use strict";
(() => {
  // _js/standalone/collection/index.js
  var collection_products = [], ppp = parseInt(document.querySelector("#ProductGridContainer")?.dataset.
  ppp), all_products_grid;
  var triggered = !1, filters_inputs = [], infiniScroll_grid = window.infiniScroll_grid, Swiper = window.
  Swiper, Shopify = window.Shopify, vm = window.vm, Vue = window.Vue, FILTER_SETTINGS = window.FILTER_SETTINGS,
  jQuery = window.jQuery, $ = window.$, disable_filters = () => {
    filters_inputs.forEach((i) => i.setAttribute("disabled", ""));
  }, enable_filters = () => {
    filters_inputs.forEach((i) => i.removeAttribute("disabled"));
  }, clearInfiniScrollGrid = () => {
    infiniScroll_grid.querySelectorAll(".grid__item").forEach((item) => {
      item.remove();
    });
  }, updateInfiniScrollGrid = () => {
    if (infiniScroll_grid) {
      let infiniScroll_items = infiniScroll_grid.querySelectorAll(".grid__item"), count = 0;
      for (; count < ppp && infiniScroll_items[count]; )
        infiniScroll_items[count].remove(), count++;
    }
  };
  (() => {
    let { createApp: createApp2 } = Vue, ConvertStringToHTML = (str) => new DOMParser().parseFromString(
    str, "text/html").body, initScrollToTop = () => {
      document.querySelectorAll(".btn-scroll-top").forEach(($btn) => {
        $btn.addEventListener("click", (e) => {
          e.preventDefault(), window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
        });
      });
    }, SESSION_KEY_CACHE = "collection_pages", PAGES_CACHE = JSON.parse(sessionStorage.getItem(SESSION_KEY_CACHE)) ||
    [], SESSION_KEY_SCROLLTOP = "scroll_top", scrollTop = sessionStorage.getItem(SESSION_KEY_SCROLLTOP) ||
    0, loadCollection = (url) => {
      let timeout = scrollTop === 0 ? 1e3 : 0;
      return new Promise((resolve) => {
        let cachedPage = PAGES_CACHE.find((item) => item.url === url);
        cachedPage ? setTimeout(() => {
          resolve(cachedPage.res);
        }, timeout) : fetch(url).then((res) => res.text()).then((res) => {
          PAGES_CACHE.push({
            index: vm.next_page_index,
            url,
            res
          }), sessionStorage.setItem(
            SESSION_KEY_CACHE,
            JSON.stringify(PAGES_CACHE)
          ), resolve(res);
        }).catch(console.error);
      });
    }, vms_products2 = [], VueProductCards = () => {
      vms_products2 = Array.from(
        document.querySelectorAll(".card-wrapper:not(.v-initialized)")
      ).map(($card) => {
        let $productJsonData = $card.querySelector("[data-product-json]"), product = JSON.parse($productJsonData.
        value), options_with_values = JSON.parse(
          $card.querySelector("[data-product-options-with-values-json]").value
        );
        product.options_with_values = options_with_values, $card.querySelectorAll("a").forEach(($a) => {
          $a.addEventListener("click", (e) => {
            sessionStorage.setItem(SESSION_KEY_SCROLLTOP, window.pageYOffset);
          });
        });
        let vm_product;
        return product && (vm_product = createApp2({
          delimiters: ["${", "}"],
          data() {
            return { product };
          },
          mounted() {
            this.initImagesSwiper(), $card.classList.add("v-initialized");
          },
          computed: {},
          methods: {
            initImagesSwiper() {
              let $images = $card.querySelector(".product-images-swiper"), initialSlide = window.innerWidth <
              768 ? 0 : 1;
              new Swiper($images, {
                touchMove: !0,
                speed: 250,
                loop: !1,
                slidesToShow: 1,
                slidesToScroll: 1,
                initialSlide,
                slidesPerView: "auto",
                shortSwipes: !0,
                touchStartPreventDefault: !1,
                threshold: 10,
                pagination: {
                  el: $card.querySelector(".swiper-pagination"),
                  clickable: !0
                },
                navigation: {
                  nextEl: $card.querySelector(".swiper-button-next"),
                  prevEl: $card.querySelector(".swiper-button-prev")
                }
              });
            },
            addItemToCart(e) {
              e.preventDefault();
              let $form = e.currentTarget.closest("form"), variants = [
                {
                  quantity: 1,
                  id: $form.querySelector("input[name=id]").value
                }
              ];
              $form.querySelector('input[value="PRE-ORDER"]') && (variants[0].properties = {
                "": "PRE-ORDER"
              });
              let items = {
                items: variants,
                sections: "cart-drawer"
              };
              fetch(window.Shopify.routes.root + "cart/add.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify(items)
              }).then((res) => res.json()).then((parsedState) => {
                if (parsedState.sections && parsedState.sections["cart-drawer"]) {
                  let $cartDrawer = Shopify.theme.utils.stringToHTML(
                    parsedState.sections["cart-drawer"]
                  );
                  document.querySelector(
                    "#cart-drawer .cart-items"
                  ).innerHTML = $cartDrawer.querySelector(".cart-items").innerHTML, document.dispatchEvent(
                  new CustomEvent("product:added"));
                } else
                  document.dispatchEvent(
                    new CustomEvent("cart:update", {
                      detail: { openDrawer: !0 }
                    })
                  );
              }).catch(console.error);
            }
          }
        }).mount($card.querySelector(".card-quick-add"))), vm_product;
      });
    }, vm_paginate, ProductsInfiniteLoad = () => {
    }, CollectionFilters = () => {
      let SELECTORS = {
        filterContainer: ".collection-filters-container",
        filterSection: ".collection-filters",
        productsGrid: "#product-grid",
        paginateWrapper: ".pagination-wrapper"
      };
      (() => {
        let url = `${window.location.pathname}?view=raw-full`;
        fetch(url).then((res) => res.text()).then((res) => {
          let $res = new DOMParser().parseFromString(res, "text/html").body;
          all_products_grid = $res.querySelector(SELECTORS.productsGrid), infiniScroll_grid = $res.querySelector(
          SELECTORS.productsGrid).cloneNode(!0), updateInfiniScrollGrid();
        });
      })(), function fetch_collection(i) {
        fetch(`${window.location.href}/products.json?page=${i}`).then((res) => res.json()).then((res) => {
          res.products.length && (res.products.forEach((product) => collection_products.push(product)),
          fetch_collection(i + 1));
        });
      }(1);
      let $filterSection = document.querySelector(SELECTORS.filterSection);
      if (!$filterSection || !FILTER_SETTINGS)
        return;
      let page_url = $filterSection.dataset.url, vm_filters = createApp2({
        delimiters: ["${", "}"],
        data() {
          return { FILTER_SETTINGS, selected_tags: [], page_url };
        },
        computed: {
          collection_tags() {
            return this.FILTER_SETTINGS.all_tags;
          },
          filters() {
            return this.FILTER_SETTINGS.blocks.map((block) => {
              let joinedSizeTags = [];
              block.title === "Size" && (joinedSizeTags = this.collection_tags.filter(
                (joinedTag) => joinedTag.includes("/")
              ), joinedSizeTags = [
                ...new Set(joinedSizeTags.flatMap((size) => size.split("/")))
              ]);
              let filter_tags = block.filter_tags.split(", ").filter(
                (filter_tag) => this.collection_tags.indexOf(filter_tag) !== -1 || joinedSizeTags.includes(
                filter_tag)
              );
              return {
                title: block.title,
                filter_tags_handle: block.filter_tags_handle,
                filter_tags
              };
            });
          },
          url_with_selected_tags() {
            let tags_join = this.selected_tags.map((tag) => tag.replaceAll(/ /g, "-")).join("+");
            return `${page_url}/${tags_join}`;
          }
        },
        watch: {
          selected_tags() {
            this.loadResults();
          }
        },
        methods: {
          updateUrl() {
            window.history.pushState(
              {},
              document.title,
              this.url_with_selected_tags
            );
          },
          loadResults() {
            disable_filters();
            let has_size = !1, selected_sizes = [], backToTop = document.querySelector(".back-to-top");
            if (Object.keys(this.selected_tags).length) {
              for (let tag of this.selected_tags)
                for (let filter of this.filters)
                  filter.title === "Size" && filter.filter_tags.includes(tag) && (selected_sizes.push(
                  tag), has_size = !0);
              if (has_size) {
                let has_only_size = !0;
                for (let tag of this.selected_tags)
                  if (!selected_sizes.includes(tag)) {
                    has_only_size = !1;
                    break;
                  }
                has_size = !has_only_size;
              }
              let filtered_products = [];
              if (selected_sizes.length && has_size) {
                for (let product of collection_products)
                  for (let tag of this.selected_tags)
                    if (!selected_sizes.includes(tag))
                      for (let size_tag of selected_sizes) {
                        let joinedSizeTagsArray = (product.tags?.filter(
                          (product_tag) => product_tag.includes("/")
                        )).flatMap(
                          (size) => size.split("/")
                        );
                        if (product.tags?.includes(tag) && (product.tags?.includes(size_tag) || joinedSizeTagsArray.
                        includes(size_tag)) && !filtered_products.includes(product.id)) {
                          filtered_products.push(product.id);
                          break;
                        }
                      }
              } else
                for (let product of collection_products)
                  for (let tag of this.selected_tags) {
                    let joinedSizeTagsArray = (product.tags?.filter(
                      (product_tag) => product_tag.includes("/")
                    )).flatMap(
                      (size) => size.split("/")
                    );
                    (product.tags?.includes(tag) || joinedSizeTagsArray.includes(tag)) && (filtered_products.
                    includes(product.id) || filtered_products.push(product.id));
                  }
              for (let item of all_products_grid.querySelectorAll(
                ".grid__item"
              ))
                filtered_products.includes(parseInt(item.dataset.pid)) || item.remove();
              let products = all_products_grid.querySelectorAll(".grid__item"), $products_grid = document.
              querySelector(SELECTORS.productsGrid);
              if ($products_grid.innerHTML = "", products.length) {
                document.querySelector(".collection--empty").style.display = "none", backToTop && (backToTop.
                style.display = "none"), document.querySelector("#more") && (document.querySelector(
                "#more").style.display = "none"), products.length > ppp && document.querySelector("#\
more") && (document.querySelector("#more").style.display = "block");
                for (let i = 0; i < ppp && products[i]; i++)
                  products[i].classList.add("shown"), $products_grid.insertAdjacentElement("beforeen\
d", products[i]);
                products = all_products_grid.querySelectorAll(".grid__item"), !products.length && backToTop &&
                (backToTop.style.display = "block"), clearInfiniScrollGrid();
                for (let i = 0; i < products.length; i++)
                  products[i].classList.add("shown"), infiniScroll_grid.insertAdjacentElement(
                    "beforeend",
                    products[i]
                  );
                triggered = !1, VueProductCards(), (() => {
                  let url = `${window.location.pathname}?view=raw-full`;
                  fetch(url).then((res) => res.text()).then((res) => {
                    all_products_grid = new DOMParser().parseFromString(res, "text/html").body.querySelector(
                      SELECTORS.productsGrid
                    ), enable_filters();
                  });
                })();
              } else {
                (() => {
                  let url = `${window.location.pathname}?view=raw-full`;
                  fetch(url).then((res) => res.text()).then((res) => {
                    all_products_grid = new DOMParser().parseFromString(res, "text/html").body.querySelector(
                      SELECTORS.productsGrid
                    );
                  });
                })(), document.querySelector(".collection--empty").style.display = "block", backToTop &&
                (backToTop.style.display = "none"), document.querySelector("#more") && (document.querySelector(
                "#more").style.display = "none");
                let $products_grid2 = document.querySelector(
                  SELECTORS.productsGrid
                );
                clearInfiniScrollGrid();
                let products2 = all_products_grid.querySelectorAll(".grid__item");
                $products_grid2.innerHTML = "", products2.length > ppp && document.querySelector("#m\
ore") && (document.querySelector("#more").style.display = "block");
                for (let i = 0; i < ppp && products2[i]; i++)
                  products2[i].classList.add("shown"), $products_grid2.insertAdjacentElement("before\
end", products2[i]);
                products2 = all_products_grid.querySelectorAll(".grid__item");
                for (let i = 0; i < products2.length; i++)
                  products2[i].classList.add("shown"), infiniScroll_grid.insertAdjacentElement(
                    "beforeend",
                    products2[i]
                  );
                enable_filters(), VueProductCards();
              }
            } else {
              enable_filters();
              let url = `${window.location.pathname}?view=raw-full`;
              fetch(url).then((res) => res.text()).then((res) => {
                all_products_grid = new DOMParser().parseFromString(res, "text/html").body.querySelector(
                SELECTORS.productsGrid);
              }), backToTop && (backToTop.style.display = "none"), document.querySelector("#more") &&
              (document.querySelector("#more").style.display = "none");
              let $products_grid = document.querySelector(SELECTORS.productsGrid);
              clearInfiniScrollGrid();
              let products = all_products_grid?.cloneNode(!0).querySelectorAll(".grid__item");
              if ($products_grid.innerHTML = "", products.length) {
                triggered = !1, backToTop && (backToTop.style.display = "none"), document.querySelector(
                "#more") && (document.querySelector("#more").style.display = "block"), document.querySelector(
                ".collection--empty").style.display = "none";
                for (let i = 0; i < ppp && products[i]; i++)
                  products[i].classList.add("shown"), $products_grid.insertAdjacentElement("beforeen\
d", products[i]);
                products = all_products_grid.querySelectorAll(".grid__item");
                for (let i = 0; i < products.length; i++)
                  products[i].classList.add("shown"), infiniScroll_grid.insertAdjacentElement(
                    "beforeend",
                    products[i]
                  );
                VueProductCards();
              } else
                document.querySelector(".collection--empty").style.display = "block";
            }
          },
          toggleFilters(e) {
            let target = e.currentTarget, $accordionContent = $(target).closest(".accordion").find("\
.accordion__content"), isOpen = $accordionContent.hasClass("filter-open");
            $accordionContent.toggleClass("filter-open"), $accordionContent.slideToggle("ease"), $(target).
            toggleClass("devSvg");
          },
          toggleFilter(tag) {
            let filterInput = document.querySelector(
              `.filters-wrap input[value="${tag}"]`
            );
            if (!filterInput || filterInput.disabled)
              return;
            this.selected_tags.includes(tag) ? this.selected_tags = this.selected_tags.filter((t) => t !==
            tag) : this.selected_tags = [...this.selected_tags, tag];
          }
        }
      }).mount($filterSection);
    };
    document.addEventListener("DOMContentLoaded", () => {
      CollectionFilters(), filters_inputs = document.querySelectorAll(".filters-wrap input"), window.
      performance && window.performance.navigation.type === window.performance.navigation.TYPE_BACK_FORWARD &&
      localStorage.items_on_load || VueProductCards(), initScrollToTop();
    }), document.addEventListener("product-cards--loaded", () => {
      setTimeout(VueProductCards, 0);
    });
  })();
  var { createApp } = Vue, vms_products = [], VueProductCardsDann = () => {
    vms_products = Array.from(
      document.querySelectorAll(".card-wrapper:not(.v-initialized)")
    ).map(($card) => {
      let $productJsonData = $card.querySelector("[data-product-json]"), product = JSON.parse($productJsonData.
      value), options_with_values = JSON.parse(
        $card.querySelector("[data-product-options-with-values-json]").value
      );
      product.options_with_values = options_with_values;
      let vm_product;
      return product && (vm_product = createApp({
        delimiters: ["${", "}"],
        data() {
          return { product };
        },
        mounted() {
          this.initImagesSwiper(), $card.classList.add("v-initialized");
        },
        computed: {},
        methods: {
          initImagesSwiper() {
            let $images = $card.querySelector(".product-images-swiper"), initialSlide = window.innerWidth <
            768 ? 0 : 1;
            new Swiper($images, {
              touchMove: !0,
              speed: 250,
              loop: !1,
              slidesToShow: 1,
              slidesToScroll: 1,
              initialSlide,
              slidesPerView: "auto",
              touchStartPreventDefault: !1,
              shortSwipes: !0,
              threshold: 10,
              pagination: {
                el: $card.querySelector(".swiper-pagination"),
                clickable: !0
              },
              navigation: {
                nextEl: $card.querySelector(".swiper-button-next"),
                prevEl: $card.querySelector(".swiper-button-prev")
              }
            });
          },
          addItemToCart(e) {
            e.preventDefault();
            let $form = e.currentTarget.closest("form"), variants = [
              {
                quantity: 1,
                id: $form.querySelector("input[name=id]").value
              }
            ];
            $form.querySelector('input[value="PRE-ORDER"]') && (variants[0].properties = {
              "": "PRE-ORDER"
            });
            let items = {
              items: variants,
              sections: "cart-drawer"
            };
            fetch(window.Shopify.routes.root + "cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(items)
            }).then((res) => res.json()).then((parsedState) => {
              if (parsedState.sections && parsedState.sections["cart-drawer"]) {
                let $cartDrawer = Shopify.theme.utils.stringToHTML(
                  parsedState.sections["cart-drawer"]
                );
                document.querySelector("#cart-drawer .cart-items").innerHTML = $cartDrawer.querySelector(
                ".cart-items").innerHTML, document.dispatchEvent(new CustomEvent("product:added"));
              } else
                document.dispatchEvent(
                  new CustomEvent("cart:update", {
                    detail: { openDrawer: !0 }
                  })
                );
            }).catch(console.error);
          }
        }
      }).mount($card.querySelector(".card-quick-add"))), vm_product;
    });
  }, ScrollExecute = () => {
    if (triggered === !1) {
      let infini_interval = setInterval((f) => {
        if (infiniScroll_grid) {
          let product_grid = document.querySelector("#product-grid"), infiniScroll_products = infiniScroll_grid.
          querySelectorAll(".grid__item");
          for (let i = 0; i < ppp; i++)
            if (infiniScroll_products[i])
              infiniScroll_products[i].classList.add("shown"), product_grid.insertAdjacentElement(
                "beforeend",
                infiniScroll_products[i]
              ), triggered = !1;
            else {
              document.querySelector(".back-to-top") && (document.querySelector(".back-to-top").style.
              display = "block"), document.querySelector("#more") && (document.querySelector("#more").
              style.display = "none"), triggered = !0;
              break;
            }
          VueProductCardsDann(), clearInterval(infini_interval);
        } else
          console.log("waiting"), triggered = !0;
      }, 10);
    }
  }, loaderObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      entry.isIntersecting ? ScrollExecute() : console.log("no scrollexec");
    });
  });
  document.getElementById("more") && loaderObserver.observe(document.getElementById("more"));
  jQuery(document).ready(() => {
    jQuery(document).on("click", ".devDisabled", function() {
      var ID = jQuery(this).attr("devVarinatId");
      console.log(ID);
      var varId = jQuery(".accordion__content .size-swatch input ").attr(
        "data-variant"
      );
      console.log(varId);
    });
  });
  var initializeButtonBehavior = () => {
    let disableNewButtons = (mutationsList) => {
      for (let mutation of mutationsList)
        mutation.type === "childList" && document.querySelectorAll("#devIdCol").forEach((button) => {
          button.disabled = !0;
        });
    }, handleResize = () => {
      let devIdColButtons = document.querySelectorAll("#devIdCol");
      if (window.innerWidth > 767) {
        devIdColButtons.forEach((button) => {
          button.disabled = !0;
        });
        let targetNode = document.body, observer = new MutationObserver(disableNewButtons), config = {
        childList: !0, subtree: !0 };
        observer.observe(targetNode, config);
      } else
        devIdColButtons.forEach((button) => {
          button.disabled = !1;
        });
    };
    handleResize(), window.addEventListener("resize", handleResize);
  };
  initializeButtonBehavior();
})();
